import styled from 'styled-components';
import type { ThemeTypes } from 'types/Theme.namespace';

const DisplayTag = styled.div<{
  backgroundColor: ThemeTypes.Colors;
  borderColor: ThemeTypes.Colors;
  textColor: ThemeTypes.Colors;
}>`
  box-sizing: border-box;
  overflow: hidden;
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.fontSize.B14};
  padding: ${({ theme }) => `${theme.spacing.S8} ${theme.spacing.S12}`};
  border-radius: 17px; // This is half the height of the tag to give a full round on each end.
  background-color: ${({ theme, backgroundColor }) =>
    theme.colors[backgroundColor]};
  border: ${({ theme, borderColor }) =>
    `1px solid ${theme.colors[borderColor]};`};
  color: ${({ theme, textColor }) => theme.colors[textColor]};
`;

export { DisplayTag };
